// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-O":"O_dpu-detail-O__wiFWJ"};